import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckifuserComponent } from './checkifuser/checkifuser.component';
import { CreateorgComponent } from './createorg/createorg.component';
import { CreateuserComponent } from './createuser/createuser.component';
import { EditorgComponent } from './editorg/editorg.component';
import { EdituserComponent } from './edituser/edituser.component';
import { HomepageComponent } from './homepage/homepage.component';
import { LoginComponent } from './login/login.component';
import { VieworgComponent } from './vieworg/vieworg.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'homepage', component: HomepageComponent },
  { path: 'checkifuser', component: CheckifuserComponent },
  { path: 'createuser', component: CreateuserComponent },
  { path: 'createorg', component: CreateorgComponent },
  { path: 'edituser', component: EdituserComponent },
  { path: 'editorg', component: EditorgComponent },
  { path: 'vieworg/:org', component: VieworgComponent },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
